import React, { useEffect, useState, useCallback } from "react";
import { API } from "../services/config";
import "./BalanceSemanal.css";

export default function BalanceSemanal({ onClose, token, profesionalId }) {
  const [balance, setBalance] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [enviando, setEnviando] = useState(false);

  const fetchBalance = useCallback(async () => {
    try {
      setLoading(true);
      const qs = profesionalId ? `?profesional_id=${profesionalId}` : "";
      const response = await fetch(`${API}/balance-semanal${qs}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const data = await response.json();
      if (data.success) {
        setBalance(data.data);
      }
    } catch (err) {
      setError("Error al cargar el balance");
      console.error(err);
    } finally {
      setLoading(false);
    }
  }, [token]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (token) {
      fetchBalance();
    }
  }, [token, fetchBalance]);

  const enviarEmail = async () => {
    try {
      setEnviando(true);
      const response = await fetch(`${API}/balance-semanal/enviar-email`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          desde: balance.periodo.desde,
          hasta: balance.periodo.hasta,
          profesional_id: profesionalId || null,
        }),
      });
      const data = await response.json();
      if (data.success) {
        alert("Email enviado correctamente");
      } else {
        alert("Error al enviar email");
      }
    } catch (err) {
      alert("Error al enviar email: " + err.message);
    } finally {
      setEnviando(false);
    }
  };

  if (loading) return <div className="balance-modal"><div className="balance-contenido">Cargando...</div></div>;
  if (error) return <div className="balance-modal"><div className="balance-contenido">{error}</div></div>;
  if (!balance) return <div className="balance-modal"><div className="balance-contenido">No hay datos</div></div>;

  const { periodo, totales, gastosPorCategoria, turnos, gastos } = balance;

  return (
    <div className="balance-modal">
      <div className="balance-contenido balance-semanal">
        <div className="balance-header">
          <h2 className="balance-titulo">Balance Semanal</h2>
          <button className="balance-cerrar-x" onClick={onClose} aria-label="Cerrar">
            ✕
          </button>
        </div>

        <p className="balance-fecha">
          Del {new Date(periodo.desde).toLocaleDateString("es-AR")} al {new Date(periodo.hasta).toLocaleDateString("es-AR")}
        </p>

        <div className="balance-resumen">
          <div className="balance-resumen-item facturado">
            <span className="balance-resumen-label">Total Facturado</span>
            <span className="balance-resumen-monto">
              ${parseFloat(totales.facturado).toLocaleString("es-AR", { minimumFractionDigits: 2 })}
            </span>
          </div>
          <div className="balance-resumen-item gastado">
            <span className="balance-resumen-label">Total Gastado</span>
            <span className="balance-resumen-monto">
              -${parseFloat(totales.gastado).toLocaleString("es-AR", { minimumFractionDigits: 2 })}
            </span>
          </div>
          <div className={`balance-resumen-item margen ${totales.margen >= 0 ? "positivo" : "negativo"}`}>
            <span className="balance-resumen-label">Margen</span>
            <span className="balance-resumen-monto">
              ${parseFloat(totales.margen).toLocaleString("es-AR", { minimumFractionDigits: 2 })}
            </span>
          </div>
        </div>

        {gastosPorCategoria.length > 0 && (
          <div className="balance-categoria">
            <h3>Desglose de Gastos</h3>
            <table className="balance-tabla">
              <thead>
                <tr>
                  <th>Categoría</th>
                  <th>Cantidad</th>
                  <th>Total</th>
                </tr>
              </thead>
              <tbody>
                {gastosPorCategoria.map((g, i) => (
                  <tr key={i}>
                    <td className={`categoria-${g.categoria}`}>{g.categoria.toUpperCase()}</td>
                    <td>{g.cantidad}</td>
                    <td>${parseFloat(g.total).toLocaleString("es-AR", { minimumFractionDigits: 2 })}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {turnos.length > 0 && (
          <div className="balance-detalle">
            <h3>Servicios Facturados ({turnos.length})</h3>
            <div className="balance-lista">
              {turnos.map((t, i) => (
                <div key={i} className="balance-item">
                  <div className="balance-item-info">
                    <span className="balance-item-nombre">
                      {t.pacienteRelacion?.nombre} {t.pacienteRelacion?.apellido}
                    </span>
                    <span className="balance-item-motivo">{t.title}</span>
                    <span className="balance-item-fecha">
                      {new Date(t.start).toLocaleDateString("es-AR")}
                    </span>
                  </div>
                  <span className="balance-item-monto">
                    ${parseFloat(t.monto || 0).toLocaleString("es-AR", { minimumFractionDigits: 2 })}
                  </span>
                </div>
              ))}
            </div>
          </div>
        )}

        {gastos.length > 0 && (
          <div className="balance-detalle">
            <h3>Gastos Registrados ({gastos.length})</h3>
            <div className="balance-lista">
              {gastos.map((g, i) => (
                <div key={i} className="balance-item gasto">
                  <div className="balance-item-info">
                    <span className="balance-item-nombre">{g.descripcion}</span>
                    <span className={`balance-item-categoria categoria-${g.categoria}`}>
                      {g.categoria.toUpperCase()}
                    </span>
                    <span className="balance-item-fecha">
                      {new Date(g.fecha).toLocaleDateString("es-AR")}
                    </span>
                  </div>
                  <span className="balance-item-monto negativo">
                    -${parseFloat(g.monto).toLocaleString("es-AR", { minimumFractionDigits: 2 })}
                  </span>
                </div>
              ))}
            </div>
          </div>
        )}

        <div className="balance-acciones">
          <button 
            className="balance-email-btn" 
            onClick={enviarEmail}
            disabled={enviando}
          >
            {enviando ? "Enviando..." : "📧 Enviar por Email"}
          </button>
          <button className="balance-cerrar-btn" onClick={onClose}>
            Cerrar
          </button>
        </div>
      </div>
    </div>
  );
}
